import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fileSize',
})
export class FileSizePipe implements PipeTransform {
  transform(totalSize: any): any {
    if (!totalSize) {
      return null;
    }
    return (totalSize / Math.pow(1024, 1)).toFixed(2);
  }
}
